import Vue from 'vue';
import OnlineCashesPay from './OnlineCashesPay.vue'
import OnlineCashesForm from './OnlineCashesForm.vue'
import OnlineCashesCheck from './OnlineCashesCheck.vue'
import OnlineCashesButtonTable from './OnlineCashesButtonTable.vue'
import OnlineCashesButtonCertificate from './OnlineCashesButtonCertificate.vue'

Vue.component('OnlineCashesPay', OnlineCashesPay);
Vue.component('OnlineCashesForm', OnlineCashesForm);
Vue.component('OnlineCashesCheck', OnlineCashesCheck);
Vue.component('OnlineCashesButtonTable', OnlineCashesButtonTable);
Vue.component('OnlineCashesButtonCertificate', OnlineCashesButtonCertificate);
